module.exports = __webpack_public_path__ + "img/pole-gray-lb.c9f7fdc3.png";